import './App.css';
import Main from './Components/home/MainApp.jsx';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Msoffice from './Components/courses/msoffice/Msoffice.jsx';
import Dtp from './Components/courses/dtp/Dtp.jsx';
import Clanguage from './Components/courses/c_language/Clanguage.jsx';
import Tallycs from './Components/courses/tally/Tallycs.jsx';
import Frontendhtml from './Components/courses/html/Frontendhtml.jsx';
import Videoediting from './Components/courses/videoEditing/Videoediting.jsx';
import Autoscroll from './Components/home/Autoscroll.jsx';
import { LoaderProvider } from './Components/home/lazy loader/LoaderContext.jsx';
import RouteChangeHandler from './Components/home/lazy loader/RouteChangeHandler.jsx';
import GlobalLoader from './Components/home/lazy loader/GlobalLoader.jsx';
import ContactUs from './Components/Contact Us/ContactUs.jsx';
import AboutUs from './Components/About Us/AboutUs.jsx';
import StudentWorks from './Components/Student Works/StudentWorks.jsx';
import TrainerProfile from './Components/Trainer Profile/TrainerProfile.jsx';
import Ourcourses from './Components/Our Courses/Ourcourses.jsx';
import Registration from './Components/Registration/Registration.jsx';
import Quiz from './Components/Quiz/Quiz.jsx';
import QuizContainer from './Components/Quiz/Quizcontainer.jsx';
import Login from './Components/Quiz/Login.jsx';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Autoscroll/>
      <LoaderProvider>
        <RouteChangeHandler/>
        <GlobalLoader/>
        <Routes>
          <Route path='/' element={<Main/>}/>
          <Route path='/coursedetails/ms-Office' element={<Msoffice/>}/>
          <Route path='/coursedetails/dtp' element={<Dtp/>}/>
          <Route path='/coursedetails/c-language' element={<Clanguage/>}/>
          <Route path='/coursedetails/tally' element={<Tallycs/>}/>
          <Route path='/coursedetails/html' element={<Frontendhtml/>}/>
          <Route path='/coursedetails/video-editing' element={<Videoediting/>}/>
          <Route path='/contact-us' element={<ContactUs/>}/>
          <Route path='/about-us' element={<AboutUs/>}/>
          <Route path='/student-works' element={<StudentWorks/>}/>
          <Route path='/trainer-profile' element={<TrainerProfile/>}/>
          <Route path='/our-courses' element={<Ourcourses/>}/>
          <Route path='/register-now' element={<Registration/>}/>
          <Route path='/quiz' element={<Quiz/>}/>
          <Route path='/quiz-loginPage' element={<Login/>}/>
          <Route path='/quiz-startquiz' element={<QuizContainer/>}/>
        </Routes>
        </LoaderProvider>
      </BrowserRouter>

    </div>
  );
}

export default App;
